<div fxLayout="row">
    <div fxFlex="40px">
        <app-generic-status-icon [state]="state"></app-generic-status-icon>
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>